import * as React from 'react'
import moment from 'moment'
import { ActionsCell } from './ActionsCell'

export const columns = [
  {
    accessorKey: 'Candidate',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => {
      const url = props.row.original.candidate_url
      const name = props.row.original.candidate
      return url ? <a href={url}>{name}</a> : name
    },
  },
  {
    accessorKey: 'Program Level',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => props.row.original.candidate_program_level,
  },
  {
    accessorKey: 'Coach Service',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => props.row.original.service_request,
  },
  {
    accessorKey: 'Created',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => moment(props.row.original.created_at).format('L'),
  },
  {
    accessorKey: 'Start Time',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => {
      const raw = props.row.original.meeting_time
      if (!raw) return ''
      return moment(raw).format('MM/DD/YYYY h:mm A')
    },
  },
  {
    accessorKey: 'Actions',
    header: (props) => <EmptyTableHeader {...props} />,
    cell: (props) => <ActionsCell {...props} />,
    enableSorting: false,
  },
]

function TableHeader({ column }) {
  return <div className="font-roboto">{column.id}</div>
}

function EmptyTableHeader() {
  return <div className="font-roboto"></div>
}
